import { render, staticRenderFns } from "./OfficialBusinessTrip.vue?vue&type=template&id=2e60b6ef&scoped=true"
import script from "./OfficialBusinessTrip.vue?vue&type=script&lang=js"
export * from "./OfficialBusinessTrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60b6ef",
  null
  
)

export default component.exports